import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardText,[_c(VBtnToggle,{staticClass:"data-list-mode-toggler",attrs:{"mandatory":""},model:{value:(_vm.currentListMode),callback:function ($$v) {_vm.currentListMode=$$v},expression:"currentListMode"}},_vm._l((_vm.listModes),function(listMode){return _c(VBtn,{key:listMode,attrs:{"value":listMode}},[_vm._v(" "+_vm._s(_vm.$t(("monitoring.data." + listMode)))+" ")])}),1)],1),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }